import mergeWith from 'lodash/mergeWith';

import isNil from 'Lib/utils/isNil';

import { matchMergeStrategy } from 'Store/match/utils';

import {
  ARCHIVED_MATCHES_ENTITY_KEY,
  MATCHES_ENTITY_KEY,
  MESSAGES_ENTITY_KEY,
  PROFILE_ENTITY_KEY,
} from './entityKeys';

/**
 * Merges two entities, overwriting any existing keys
 *
 * This is appropriate for flat entities that do not require deep merging or array concatenation
 */
// @TODO, same function in persist reconsiler, should consolidate
export function mergeEntityPatch(previousEntity, updatedEntity) {
  if (!previousEntity) {
    return updatedEntity;
  }
  return mergeWith(previousEntity, updatedEntity, (a, b) => (isNil(b) && !isNil(a) ? a : b));
}

export function assignEntityPatch(previousEntity, updatedEntity) {
  return {
    ...previousEntity,
    ...updatedEntity,
  };
}

/**
 * Merge strategies
 *
 * Allows you define a custom merge strategy rather than the default overwrite-by-ID.
 */
export default {
  [MATCHES_ENTITY_KEY]: matchMergeStrategy,
  [ARCHIVED_MATCHES_ENTITY_KEY]: mergeEntityPatch,
  [MESSAGES_ENTITY_KEY]: assignEntityPatch,
  [PROFILE_ENTITY_KEY]: mergeEntityPatch,
};
